import { marker } from "@jsverse/transloco-keys-manager/marker";
import { absoluteUrl } from "src/app/support/navigation";
import { NavigationBarItem } from "../bootstrap-components/navigation-bar/navigation-bar-item";
import { sntTranslate } from "src/app/support/translate";

export function getPmsSettingsMenu(): NavigationBarItem[] {
  return [
    {
      title: sntTranslate(marker("Account")),
      url: absoluteUrl("/account"),
      icon: "fa-light fa-circle-user"
    }
  ];
}
